import ReqTrasladoComponent from "@/components/inventario/req_traslado/ReqTrasladoComponent";
import ReqTrasladoFormComponent from "@/components/inventario/req_traslado/ReqTrasladoFormComponent";
import CotizacionesRequerimientoComponent from "@/components/inventario/cotizaciones_requerimiento/CotizacionesRequerimientoComponent";
import CotizacionRequerimientoFormComponent from "@/components/inventario/cotizaciones_requerimiento/CotizacionRequerimientoFormComponent";

import SalidaTrasladoComponent from "@/components/inventario/salida_traslado/SalidaTrasladoComponent";
import SalidaTrasladoFormComponent from "@/components/inventario/salida_traslado/SalidaTrasladoFormComponent";

import EntradaTrasladoComponent from "@/components/inventario/entrada_traslado/EntradaTrasladoComponent";
import EntradaTrasladoFormComponent from "@/components/inventario/entrada_traslado/EntradaTrasladoFormComponent";

import EntradaCompraComponent from "@/components/inventario/entrada_compra/EntradaCompraComponent";
import EntradaCompraFormComponent from "@/components/inventario/entrada_compra/EntradaCompraFormComponent";

import EnvioInventarioComponent from "@/components/inventario/envio_inventario/EnvioInventarioComponent";
import EnvioInventarioFormComponent from "@/components/inventario/envio_inventario/EnvioInventarioFormComponent";
import EnvioInventarioView from "@/components/inventario/envio_inventario/EnvioInventarioView";

import AjusteInventarioComponent from "@/components/inventario/ajuste_inventario/AjusteInventarioComponent";
import AjusteInventarioFormComponent from "@/components/inventario/ajuste_inventario/AjusteInventarioFormComponent";

import DevolucionesComponent from "@/components/inventario/devoluciones/DevolucionesComponent";
import DevolucionesFormComponent from "@/components/inventario/devoluciones/DevolucionesFormComponent";
import DevolucionesNewFormComponent from "@/components/inventario/devoluciones/DevolucionesNewFormComponent";

import devolucionProveedorFormComponent from "@/components/inventario/devolucion_proveedor/devolucionProveedorFormComponent";
import devolucionProveedorComponent from "@/components/inventario/devolucion_proveedor/devolucionProveedorComponent";

import TrasladosTiendasComponent from "@/components/inventario/traslados/TrasladosTiendasComponent";

import RptKardexComponent from "@/components/inventario/reportes/RptKardexComponent";
import RptPisoSkusVentasInv from "@/components/inventario/reportes/RptPisoSkusVentasInv";

import RptRequerimientosComponent from "@/components/inventario/reportes/RptRequerimientosComponent";
import RptInventarioNegativoComponent from "@/components/inventario/reportes/RptInventarioNegativoComponent";
import RptPartSkuCatTiendaComponent from "@/components/inventario/reportes/RptPartSkuCatTiendaComponent";

import ConversionesComponent from "@/components/inventario/conversiones/ConversionesComponent";
import ConversionesFormComponent from "@/components/inventario/conversiones/ConversionesFormComponent";

import ReqAbiertasReportComponent from "@/components/compras/reportes/ReqAbiertasReportComponent";

import ConteoInventarioComponent from "@/components/inventario/conteo_inventario/ConteoInventarioComponent";
import ConteoInventarioFormComponent from "@/components/inventario/conteo_inventario/ConteoInventarioFormComponent";

import ConteoAgrupadoComponent from "@/components/inventario/conteo_agrupado/ConteoAgrupadoComponent";
import ConteoAgrupadoFormComponent from "@/components/inventario/conteo_agrupado/ConteoAgrupadoFormComponent";


import Inconsistencias_por_fecha from "@/components/inventario/reportes/inconsistencias_por_fecha/Inconsistencias_por_fecha";

import TarimaFormComponent from "@/components/inventario/tarimas/TarimaFormComponent";
import TarimaComponent from "@/components/inventario/tarimas/TarimaComponent";
import MovimientosTarimaPageComponent from "@/components/inventario/tarimas/MovimientosTarimaPageComponent";

import TarimaDevolucionComponent from "@/components/inventario/tarimas_devoluciones/TarimaDevolucionComponent";
import TarimaDevolucionFormComponent from "@/components/inventario/tarimas_devoluciones/TarimaDevolucionFormComponent";

import PendientePedirComponent from "@/components/inventario/pendiente_pedir/PendientePedirComponent";

import ReqAbiertasComponent from "@/components/inventario/reportes/req_traslados_abiertas/ReqAbiertasComponent";

import InvPorCategoria from "@/components/inventario/reportes/InvPorCategoria";

import FacturasxDia from "@/components/inventario/reportes/facturas_por_dia/FacturasxDia";

import FacturasSinRevisar from "@/components/inventario/reportes/facturas_sin_revisar/FacturasSinRevisar";

import LiquidacionProductoComponent from "@/components/inventario/liquidacion_producto/LiquidacionProductoComponent";
import LiquidacionProductoFormComponent from "@/components/inventario/liquidacion_producto/LiquidacionProductoFormComponent";

import ReqTrasladoLocComponent from "@/components/inventario/req_traslado_localizacion/ReqTrasladoLocComponent";
import ReqTrasladoLocFormComponent from "@/components/inventario/req_traslado_localizacion/ReqTrasladoLocFormComponent";

import SalidaInventarioComponent from "@/components/inventario/salida_inventario/SalidaInventarioComponent";
import SalidaInventarioFormComponent from "@/components/inventario/salida_inventario/SalidaInventarioFormComponent";

import ReqtrasladoAnalisisComponent from "@/components/inventario/reportes/resumen_req_traslados/ReqtrasladoAnalisisComponent";
import ReqtrasladoAnalisisResumenComponent from "@/components/inventario/reportes/resumen_req_traslados/ReqtrasladoAnalisisResumenComponent";

import TrasladoLocDirectoComponent from "@/components/inventario/traslado_loc_directo/TrasladoLocDirectoComponent";


export default [
  {
    path: "/inventario/traslados_loc/",
    name: "inventario-traslados_loc",
    component: TrasladoLocDirectoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/inv-x-categoria/",
    name: "inventario-inv-x-categoria",
    component: InvPorCategoria,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/requisiciones-abiertas/",
    name: "inventario-requisiciones-abiertas",
    component: ReqAbiertasComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/requerimiento-analisis/",
    name: "inventario-requerimiento-analisis",
    component: ReqtrasladoAnalisisComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/requerimiento-analisis-resumido/",
    name: "inventario-requerimiento-analisis-resumido",
    component: ReqtrasladoAnalisisResumenComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/pendiente_pedir/",
    name: "inventario-pendiente_pedir",
    component: PendientePedirComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/tarima/:id/",
    name: "inventario-tarima-editar",
    component: TarimaFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/tarima/",
    name: "inventario-tarima",
    component: TarimaComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/tarima/:id/movimientos/",
    name: "inventario-tarima-movimientos",
    component: MovimientosTarimaPageComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/tarima_devolucion/:id/",
    name: "inventario-tarima_devolucion-editar",
    component: TarimaDevolucionFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/tarima_devoluciones/",
    name: "inventario-tarima_devoluciones",
    component: TarimaDevolucionComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/req_traslado/",
    name: "inventario-req_traslado",
    component: ReqTrasladoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/req_traslado/nuevo",
    name: "inventario-req_traslado-nuevo",
    component: ReqTrasladoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/req_traslado/editar/:id",
    name: "inventario-req_traslado-editar",
    component: ReqTrasladoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/cotizaciones-requerimiento/",
    name: "inventario-cotizaciones-requerimiento",
    component: CotizacionesRequerimientoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/cotizaciones-requerimiento/nuevo",
    name: "inventario-cotizaciones-requerimiento-nuevo",
    component: CotizacionRequerimientoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/cotizaciones-requerimiento/editar/:id",
    name: "inventario-cotizaciones-requerimiento-editar",
    component: CotizacionRequerimientoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/salida_traslado/",
    name: "inventario-salida_traslado",
    component: SalidaTrasladoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/salida_traslado/nuevo",
    name: "inventario-salida_traslado-nuevo",
    component: SalidaTrasladoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/salida_traslado/editar/:id/",
    name: "inventario-salida_traslado-editar",
    component: SalidaTrasladoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/entrada_traslado/",
    name: "inventario-entrada_traslado",
    component: EntradaTrasladoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/entrada_traslado/nuevo",
    name: "inventario-entrada_traslado-nuevo",
    component: EntradaTrasladoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/entrada_traslado/editar/:id/",
    name: "inventario-entrada_traslado-editar",
    component: EntradaTrasladoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/envio_inventario/",
    name: "inventario-envio_inventario",
    component: EnvioInventarioComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/envio_inventario/nuevo",
    name: "inventario-envio_inventario-nuevo",
    component: EnvioInventarioFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/envio_inventario/editar/:id/",
    name: "inventario-envio_inventario-editar",
    component: EnvioInventarioView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/ajuste_inventario/",
    name: "inventario-ajuste_inventario",
    component: AjusteInventarioComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/ajuste_inventario/nuevo",
    name: "inventario-ajuste_inventario-nuevo",
    component: AjusteInventarioFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/ajuste_inventario/editar/:id/",
    name: "inventario-ajuste_inventario-editar",
    component: AjusteInventarioFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/entrada_compra/",
    name: "inventario-entrada_compra",
    component: EntradaCompraComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/entrada_compra/nuevo",
    name: "inventario-entrada_compra-nuevo",
    component: EntradaCompraFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/entrada_compra/editar/:id/",
    name: "inventario-entrada_compra-editar",
    component: EntradaCompraFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/devoluciones/nuevo/",
    name: "inventario-devoluciones-nuevo",
    component: DevolucionesNewFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/devoluciones/detalle/:id/",
    name: "inventario-devoluciones-detalle",
    component: DevolucionesFormComponent,
    meta: {
      requiresAuth: true,
      permission: "",
    },
  },
  {
    path: "/inventario/devoluciones/",
    name: "inventario-devoluciones",
    component: DevolucionesComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/devoluciones/editar/:id/",
    name: "inventario-devoluciones-editar",
    component: DevolucionesNewFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/reportes/requerimientos/:sku?/:tienda?/",
    name: "inventario-reportes-requerimientos",
    component: RptRequerimientosComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/reportes/kardex/:sku?/:tienda?/",
    name: "inventario-reportes-kardex",
    component: RptKardexComponent,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/inventario/reportes/revision-piso/:sku?/:tienda?/",
    name: "inventario-reportes-revision-piso",
    component: RptPisoSkusVentasInv,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/devolucion_proveedor/editar/:id/",
    name: "inventario-devoluciones_proveedor-editar",
    component: devolucionProveedorFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/devolucion_proveedor/nuevo/",
    name: "inventario-devoluciones_proveedor-nuevo",
    component: devolucionProveedorFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/devolucion_proveedor/",
    name: "inventario-devoluciones_proveedor",
    component: devolucionProveedorComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/traslados/",
    name: "inventario-traslados",
    component: TrasladosTiendasComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/inventario-negativo/",
    name: "inventario-negativo",
    component: RptInventarioNegativoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/conversiones/",
    name: "inventario-conversiones",
    component: ConversionesComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/conversiones/:id",
    name: "inventario-conversiones-editar",
    component: ConversionesFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/part-sku-categoria-tienda/",
    name: "part-sku-categoria-tienda",
    component: RptPartSkuCatTiendaComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/solicitud-abierta/",
    name: "inventario-solicitud-abierta",
    component: ReqAbiertasReportComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/conteo-agrupado/",
    name: "inventario-conteo-agrupado",
    component: ConteoAgrupadoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/conteo-agrupado/:id",
    name: "inventario-conteo-agrupado-editar",
    component: ConteoAgrupadoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/conteo/",
    name: "inventario-conteo",
    component: ConteoInventarioComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/conteo/:id",
    name: "inventario-conteo-editar",
    component: ConteoInventarioFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/inconsistencias_traslados/",
    name: "inventario-inconsistencias_traslados",
    component: Inconsistencias_por_fecha,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/reporte/lista_facturas/",
    name: "reporte-lista_facturas",
    component: FacturasxDia,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/reporte/factura_sin_recibir/",
    name: "reporte-factura_sin_recibir",
    component: FacturasSinRevisar,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/liquidacion-producto/",
    name: "inventario-liquidacion-producto",
    component: LiquidacionProductoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/liquidacion-producto-nuevo/",
    name: "inventario-liquidacion-producto-nuevo",
    component: LiquidacionProductoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/liquidacion-producto/:id",
    name: "inventario-liquidacion-producto-editar",
    component: LiquidacionProductoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/req_traslado_loc/",
    name: "inventario-req_traslado_loc",
    component: ReqTrasladoLocComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/req_traslado_loc/nuevo",
    name: "inventario-req_traslado_loc-nuevo",
    component: ReqTrasladoLocFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/req_traslado_loc/editar/:id",
    name: "inventario-req_traslado_loc-editar",
    component: ReqTrasladoLocFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/salida_inventario/",
    name: "inventario-salida_inventario",
    component: SalidaInventarioComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/salida_inventario/nuevo",
    name: "inventario-salida_inventario-nuevo",
    component: SalidaInventarioFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/salida_inventario/editar/:id",
    name: "inventario-salida_inventario-editar",
    component: SalidaInventarioFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
];
